




import Vue from 'vue';
// http://bkicon.oa.com/resource/project/322/detail 蓝盾 iconfont 库
import '@tencent/bk-icon-wphk-ui';

export default Vue.extend({
  name: 'FitIcon',
  props: {
    /** icon名称 */
    icon: {
      type: String,
      default: 'info',
    },
    /** icon前缀，对应bkicon中的“图标前缀” */
    prefix: {
      type: String,
      default: 'icon',
    },
    /** icon库名称，对应bkicon中的“Font family” */
    namespace: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconClass() {
      return this.icon === 'loading'
        ? 'weui-loading'
        : `weui-icon-${this.icon}`;
    },
  },
});
